import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
class ContactField extends Component {
    constructor() {
        super(...arguments);
        this.handleNameChange = e => this.props.onChange('name', e.target.value);
        this.handleEmailChange = e => this.props.onChange('email', e.target.value);
        this.handlePhoneChange = e => this.props.onChange('phone', e.target.value);
        this.handleRemove = () => this.props.onRemove();
    }
    render() {
        const { contact, t } = this.props;
        const { name, email, phone } = contact;
        return (React.createElement("div", { className: "flex flex-wrap md:flex-row w-full" },
            React.createElement("div", { className: "md:w-40 w-full" },
                React.createElement("fieldset", { className: "md:mr-1" },
                    React.createElement("input", { className: "form-field block mb-4 w-full", value: name, placeholder: t("NAME"), onChange: this.handleNameChange }))),
            React.createElement("div", { className: "md:w-40 w-full" },
                React.createElement("fieldset", { className: "md:mr-1" },
                    React.createElement("input", { type: "tel", className: "form-field block mb-4 w-full", value: phone, placeholder: t("PHONE"), onChange: this.handlePhoneChange }))),
            React.createElement("div", { className: "md:w-48 w-full flex items-center" },
                React.createElement("fieldset", { className: "md:mr-1" },
                    React.createElement("input", { type: "email", className: "form-field block mb-4 w-full", value: email, placeholder: t('EMAIL'), onChange: this.handleEmailChange }))),
            React.createElement("div", { className: "w-6 border flex items-center justify-center" },
                React.createElement("button", { className: "button secondary-action mb-4", onClick: this.handleRemove },
                    React.createElement("i", { className: "fa fa-remove" })))));
    }
}
ContactField.propTypes = {
    contact: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
};
export default withTranslation()(ContactField);
